import type { LucideIcon } from 'lucide-react';
import { Tabs } from '../../../components/ui/index.js';

export interface LayoutOption<T extends string> {
  value: T;
  label: string;
  icon?: LucideIcon;
}

interface LayoutSwitcherProps<T extends string> {
  value: T;
  options: LayoutOption<T>[];
  onChange: (next: T) => void;
  ariaLabel: string;
}

/** A compact one-of-N switch (table / cards, project / all) — the segmented `Tabs` of the demo's `/ui-elements/tabs`. */
export function LayoutSwitcher<T extends string>({ value, options, onChange, ariaLabel }: LayoutSwitcherProps<T>) {
  return (
    <Tabs
      variant="segmented"
      aria-label={ariaLabel}
      tabs={options.map((o) => ({ id: o.value, label: o.label, icon: o.icon }))}
      activeTab={value}
      onChange={(id) => onChange(id as T)}
    />
  );
}
